/** Landing FAQ copy — single source for visible HTML and FAQPage JSON-LD (AEO). */
export type LandingFaqItem = {
  question: string;
  answer: string;
};

export const LANDING_FAQ_ITEMS: readonly LandingFaqItem[] = [
  {
    question: 'What is Akalan?',
    answer:
      'Akalan is an AI-powered interview prep platform. Practice voice mock interviews, scan your resume with the ATS analyzer, rewrite bullets for any job description, and get detailed feedback on clarity, STAR structure, fillers, and pace.',
  },
  {
    question: 'How many interviews can I try for free?',
    answer:
      'Free accounts get a limited number of full practice interviews with complete feedback and a shareable report. You also get daily AI Coach chats to drill weak answers. After that, buy a single interview or a 10-pack for more sessions and unlimited AI coaching.',
  },
  {
    question: 'What is the ATS resume analyzer?',
    answer:
      'Upload your resume and get a six-category ATS score with missing keywords, formatting risks, and exact fixes. Free accounts have a monthly ATS limit, and paid plans include a higher monthly limit.',
  },
  {
    question: 'How does JD resume rewrite work?',
    answer:
      'Paste a job description in Resume Rewrite. Akalan rephrases your existing bullets to mirror the role vocabulary without inventing companies, dates, or skills. Free users get a daily rewrite quota; live campaigns can raise that cap.',
  },
  {
    question: 'Which languages are supported?',
    answer:
      'You can practice in English or Hindi. Questions and feedback follow the language you choose for the session.',
  },
  {
    question: 'Are my voice and data private?',
    answer:
      'Your sessions are used to run the interview, transcription, and feedback. We use trusted infrastructure and processors as described in our privacy policy. Do not share sensitive secrets (passwords, bank OTPs) in answers.',
  },
  {
    question: 'How do payments work in India?',
    answer:
      'Paid interviews are purchased in-app through our payment partner (for example Cashfree). You will see the current price in rupees before you pay. Successful payments unlock additional sessions according to the product rules at checkout.',
  },
  {
    question: 'Can I share my report?',
    answer:
      'Yes. When sharing is enabled, you get a read-only link others can open without signing in. You can turn sharing off at any time from the report screen.',
  },
  {
    question: 'What if I leave an interview early?',
    answer:
      'If you end a session before completion, it may be marked incomplete and can count toward your interview usage. Start a fresh session from the dashboard when you are ready.',
  },
] as const;
